import FormCard from '~/themes/oknadverenamiru/components/molecule/FormCard'
import PageLogin from '~/themes/base/components/user/PageLogin'

export default {
  extends: PageLogin,
  components: {
    FormCard,
  },
}
